unit PrepareOperationScreenType;
{

/* property PrepareOperationDisposableList changed to PrepareOperationDisposableItemList, several ListTypes added/changed. */

/* Initial. */

}
interface

uses
  DisposableItemListType, PrepareOperationDisposableItemListType, PrepareOperationMedicineItemListType,
  PrepareOperationNetItemListType, PrepareOperationType, MedicineItemListType, NetItemListType,
  SpecialismListType, TypeListType;

type
  TPrepareOperationScreenType = class
  private
    fPrepareOperation: TPrepareOperationType;
    fPrepareOperationNetItemList: TPrepareOperationNetItemListType;
    fPrepareOperationDisposableItemList: TPrepareOperationDisposableItemListType;
    fPrepareOperationMedicineItemList: TPrepareOperationMedicineItemListType;
    fSpecialismList: TSpecialismListType;
    fNetItemList: TNetItemListType;
    fTypeList: TTypeListType;
    fDisposableItemList: TDisposableItemListType;
    fMedicineItemList: TMedicineItemListType;
  public
    property PrepareOperation: TPrepareOperationType read fPrepareOperation;
    property PrepareOperationNetItemList: TPrepareOperationNetItemListType read fPrepareOperationNetItemList;
    property PrepareOperationDisposableItemList: TPrepareOperationDisposableItemListType read fPrepareOperationDisposableItemList;
    property PrepareOperationMedicineItemList: TPrepareOperationMedicineItemListType read fPrepareOperationMedicineItemList;
    property SpecialismList: TSpecialismListType read fSpecialismList;
    property NetItemList: TNetItemListType read fNetItemList;
    property TypeList: TTypeListType read fTypeList;
    property DisposableItemList: TDisposableItemListType read fDisposableItemList;
    property MedicineItemList: TMedicineItemListType read fMedicineItemList;
  end;

implementation

end.
